import { PriceChange } from "@crypto-trading/common/browser";
import { getPriceChangesForPeriod } from "@/api/marketData";
import {
  CandleFetchParams,
  CandlePoint,
  ExchangeCandleRestAdapter,
} from "../../candle.types";

function toCandlePoint(change: PriceChange): CandlePoint {
  return {
    startTime: change.startTime,
    openPrice: change.openPrice,
    highPrice: change.highPrice,
    lowPrice: change.lowPrice,
    closePrice: change.closePrice,
    volume: change.volume,
  };
}

export function createApiCandlesRestAdapter(
  userId: string
): ExchangeCandleRestAdapter {
  return {
    async fetchCandles(params: CandleFetchParams): Promise<CandlePoint[]> {
      if (!params.startTime || !params.endTime) {
        throw new Error("api candles: startTime and endTime are required");
      }

      const priceChanges = await getPriceChangesForPeriod(
        userId,
        params.symbol,
        params.startTime,
        params.endTime,
        params.interval,
        0
      );

      return priceChanges.map(toCandlePoint);
    },
  };
}
